// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../sdk/types/index.d.ts" />

import { PromiseUtils } from '@app/common/utils/promise';
import { CheckoutOptions, CheckoutType } from './types';

export async function handlePayWithKontempo(options: CheckoutOptions, totalAmount: number) {
  const sdk = await loadSdk();

  const session: KontempoSdkV1.CheckoutSession = {
    merchantAccount: options.merchantAccount,
    order: {
      referenceId: options.orderId,
      summary: options.orderSummary,
      totalAmount,
    },
  };

  switch (options.type) {
    case CheckoutType.hosted: {
      sdk.initHostedCheckout(session);

      break;
    }

    case CheckoutType.modal: {
      const instance = sdk.initModalCheckout(session, {
        onCancel: () => {
          alert('Checkout Canceled!');

          instance.destroy();
        },
        onComplete: (data) => {
          console.log('Checkout Data:', data);

          alert('Checkout Complete!');
        },
        onError: (data) => {
          console.log('Checkout Error:', data);
        },
      });

      break;
    }

    case CheckoutType.inline: {
      const element = document.getElementById('inline_checkout_area') as HTMLDivElement;

      const instance = sdk.initInlineCheckout(session, {
        element,
        config: {
          language: options.language,
          showHeader: options.showHeader,
          showLanguageMenu: options.showLanguageMenu,
        },
        onCancel: () => {
          alert('Checkout Canceled!');

          instance.destroy({ removeIframe: true });
        },
        onComplete: (data) => {
          console.log('Checkout Data:', data);

          alert('Checkout Complete!');
        },
        onError: (data) => {
          console.log('Checkout Error:', data);
        },
      });

      break;
    }
  }
}

function loadSdk() {
  const defer = PromiseUtils.pending<KontempoSdkV1.Sdk>();

  Kontempo('sdk_v1.ready', (sdk) => defer.resolve(sdk));

  return defer.promise;
}
